export const SET_VIEW_LIST = 'SET_VIEW_LIST';
export const SET_VIEW_MAP  = 'SET_VIEW_MAP';
export const LIST_VIEW     = 'list';
export const MAP_VIEW      = 'map';

export const setViewList = (userActed = true) => {
    return {
        type: SET_VIEW_LIST,
        userActed 
    }
};

export const setViewMap = (userActed = true) => {
    return {
        type: SET_VIEW_MAP,
        userActed
    }
};

export const toggleView = () => {
    return (dispatch, getState) => {
        if (MAP_VIEW === getState().view.placesView)
        {
            return dispatch(setViewList());
        }
        else if (LIST_VIEW === getState().view.placesView)
        {
            return dispatch(setViewMap());
        }
    }
};



// WEBPACK FOOTER //
// ./src/actions/ViewAction.js